import { filterRecords, getRecords } from "../orm/records-mjs";
import { isRelayEdgeType } from "../relay-pagination-mjs";

function getRelatedRecords(obj, fieldName) {
  return obj[fieldName].models || obj[fieldName];
}

export default function resolveList(obj, args, context, info, type) {
  return !obj ? getRecords(type, args, context.mirageSchema) : isRelayEdgeType(type) ? obj.edges : filterRecords(getRelatedRecords(obj, info.fieldName), args);
}
